import { stringify } from 'qs';
import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';

export const RECEIVE_CASHFLOW_DATA = 'RECEIVE_CASHFLOW_DATA';

export const receive_cashflow_data = (resp, clientId) => ({
  type: RECEIVE_CASHFLOW_DATA,
  data: resp,
  clientId,
});

export const fetch_data = clientId => async dispatch => {
  try {
    const response = await fetchWithDefaults(
      `/Consumer/PersonalFinances/CashflowCategories${stringify(
        {
          clientId,
          shortLabels: true,
          period: '0',
        },
        { addQueryPrefix: true },
      )}`,
      { showSpinner: true },
    );

    const {
      payload: { viewData },
    } = await response.json();

    dispatch(receive_cashflow_data(viewData, clientId));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
